import React from "react";
import { Flame, MapPin } from "lucide-react";

const ITEMS = [
  { img: "/menu/bbq_pizza.png", name: "BBQ Pizza", price: "$14" },
  { img: "/menu/bbq_boat.png", name: "BBQ Boat", price: "$14" },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/6ad5284b-01f5-432e-9dd7-8388ae8bdde3/images/ea2515a2333c003b27a647814b302029d3cce5e873cb14aabd10c36f28866c54.png",
    name: "Pulled Pork Sandwich",
    price: "$14",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/6ad5284b-01f5-432e-9dd7-8388ae8bdde3/images/7bf2ff7d38aa446f0d911781f9ff37801a21fc0c06fdec41228765bfa8ea3d62.png",
    name: "Japanese BBQ Burger",
    price: "$14",
  },
  { img: "/menu/loaded_pork_fries.png", name: "Loaded Pork Fries", price: "$14" },
  { img: "/menu/pork_crack_mash_bowl.png", name: "Pork Crack Mash Bowl", price: "$10" },
  { img: "/menu/nacho_pork_sandwich.png", name: "Nacho Jalapeño Sandwich", price: "$10" },
  { img: "/menu/japanese_pork_sandwich.png", name: "Japanese Pork Sandwich", price: "$10" },
  { img: "/menu/mini_pulled_pork_sandwich.png", name: "Mini Pulled Pork", price: "$7" },
  { img: "/menu/mini_bbq_boat.png", name: "Mini BBQ Boat", price: "$7" },
];

function FoodCell({ item }) {
  return (
    <div className="relative overflow-hidden bg-black">
      <img
        src={item.img}
        alt={item.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.0) 30%, rgba(0,0,0,0.85) 100%)",
        }}
      />
      <div
        className="absolute top-1 right-1 bg-[#FF3B30] text-white font-['Anton'] tracking-wider px-1.5 py-0.5"
        style={{ fontSize: 12 }}
      >
        {item.price}
      </div>
      <div className="absolute inset-x-0 bottom-0 px-2 pb-1.5 z-10">
        <div
          className="font-['Anton'] uppercase text-white tracking-tight leading-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.9)]"
          style={{ fontSize: 11 }}
        >
          {item.name}
        </div>
      </div>
    </div>
  );
}

export default function FoodCollage() {
  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-6">
      <div className="flex flex-col items-center gap-6">
        <p className="font-['Outfit'] text-zinc-300 text-sm uppercase tracking-[0.3em]">
          Food Collage Ad · 1080×1080
        </p>

        <div
          data-testid="food-collage"
          className="relative w-[540px] h-[540px] overflow-hidden bg-black"
        >
          {/* 3 columns x 4 rows grid. Cell = 180 x 135. */}
          <div className="grid grid-cols-3 grid-rows-4 gap-[3px] w-full h-full bg-[#FF3B30]/30">
            {/* Brand cell — top-left */}
            <div className="relative bg-black flex flex-col items-center justify-center text-center px-2">
              <Flame
                className="text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.7)]"
                style={{ width: 20, height: 20 }}
              />
              <h2
                className="font-['Anton'] uppercase text-white leading-[0.85] mt-1.5"
                style={{ fontSize: 22, letterSpacing: "-0.02em" }}
              >
                Smokey
                <br />
                <span className="text-[#FF3B30]">AF</span>
              </h2>
              <div
                className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.3em] mt-1"
                style={{ fontSize: 7 }}
              >
                Barbecue
              </div>
            </div>

            {/* First 2 food cells */}
            <FoodCell item={ITEMS[0]} />
            <FoodCell item={ITEMS[1]} />

            {/* Row 2 - 3 food cells */}
            <FoodCell item={ITEMS[2]} />
            <FoodCell item={ITEMS[3]} />
            <FoodCell item={ITEMS[4]} />

            {/* Row 3 - 3 food cells */}
            <FoodCell item={ITEMS[5]} />
            <FoodCell item={ITEMS[6]} />
            <FoodCell item={ITEMS[7]} />

            {/* Row 4 - 2 food + 1 CTA */}
            <FoodCell item={ITEMS[8]} />
            <FoodCell item={ITEMS[9]} />
            <div
              className="relative flex flex-col items-center justify-center text-center px-2"
              style={{ background: "#FF3B30" }}
            >
              <MapPin className="w-3 h-3 text-white" />
              <div
                className="font-['Anton'] uppercase text-white tracking-wider leading-none mt-1.5"
                style={{ fontSize: 13 }}
              >
                City of
                <br />
                Fremont
              </div>
              <div
                className="font-['Anton'] uppercase tracking-widest text-black bg-white px-1.5 py-0.5 mt-2"
                style={{ fontSize: 9 }}
              >
                Order
              </div>
              <div
                className="font-['Outfit'] uppercase text-white tracking-[0.2em] mt-1"
                style={{ fontSize: 6 }}
              >
                smokey-af-bbq
              </div>
            </div>
          </div>
        </div>

        <a
          href="/fremont-food-collage.png"
          download
          data-testid="collage-dl"
          className="font-['Anton'] text-sm tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 transition-colors"
        >
          Download PNG
        </a>
      </div>
    </div>
  );
}
